<!--
 * @Author: houmy
 * @Date: 2023-09-28 14:48:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-23 17:49:08
 * @FilePath: \zx-home\src\views\ModelDetail.vue
 * @Description: 
 * 
-->
<template>
    <div class="page">
        <Contact ref="Contact"></Contact>
        <div class="modelDetailBanner">
            <img class="productDetailBannerImg" src="../assets/img//model/适配机型banner.png" alt="">
            <div class="bannerMain">
                <div class="modelBannerInfo">
                    <h1>{{ productDetail.title }}</h1>
                    <p>
                        <span @click="toProductDetail" class="toProductDetail toContact detailContact cur-poi"> <img
                                src="../assets/img/detailIcon.png" alt="">产品详情</span>

                        <button class="commonBtn toContact detailContact" @click="onlineContact">
                            <img src="../assets/img/contact2.png" alt="">产品咨询
                        </button>

                    </p>
                </div>
            </div>
        </div>
        <div class="modelMain w12 whiteBg">
            <div class="modelRouter">
                <router-link to="/">首页</router-link>
                <img src="../assets/img/right-gray.png" alt="">
                <router-link to="/products">产品中心</router-link>
                <img src="../assets/img/right-gray.png" alt="">
                <router-link :to="`/products?type=${type}`">{{ typeName }}</router-link>
                <img src="../assets/img/right-gray.png" alt="">
                <router-link :to="`/productsDetail?type=${type}&id=${productId}`">{{ productDetail.title }}</router-link>
                <img src="../assets/img/right-gray.png" alt="">
                <a>适配机型-{{ modelDetail.title }}</a>
            </div>
            <h1 class="modelTitle">
                适配机型——{{ modelDetail.title }}
            </h1>
            <div class="modelPic">
                <img :src="getImagePath(modelDetail.modelimg)" alt="">
                <span v-for="item in modelDetail.device.standard" v-if="item.left" class="bluePositionImg cur-poi"
                    @click="scrollTo(item.index, 1)" :style="itemStyle(item)">
                    {{ item.index }}
                </span>
                <span v-for="item in modelDetail.device.free" v-if="item.left" class="whitePositionImg cur-poi"
                    @click="scrollTo(item.index, 2)" :style="itemStyle(item)">
                    {{ item.index }}
                </span>

            </div>
            <div class="deviceWrap">
                <div class="home-title detail-title" style="margin-top: 24px;">
                    <div class="title-divider">
                        <img src="@/assets/img/title-left.png" alt="Divider" />
                        <span class="model-title-chinese title-chinese blackText">设备列表</span>
                        <img src="@/assets/img/title-right.png" alt="Divider" />
                    </div>
                    <span class="title-english">{{ 'Device list'.toUpperCase() }}</span>

                </div>
                <div class="deviceMain">
                    <ul class="standBox">
                        <b>标配设备</b>
                        <li v-for="(item, index) in modelDetail.device.standard" ref="listItem" :data-index="item.index">
                            <div class="deviceIndex">
                                <img src="../assets/img/model/shuzibiaoB.png" alt="">
                                <i>{{ item.index }}</i>
                            </div>
                            <img class="deviceModelImg" :src="getImagePath(item.img)" alt="">
                            <div class="deviceName">
                                <p>{{ item.name }}</p>
                                <span>{{ item.desc }}</span>
                            </div>
                        </li>
                    </ul>
                    <ul class="freeBox">
                        <b>选配设备</b>
                        <li v-for="(item, index) in modelDetail.device.free" ref="listItem2" :data-index="item.index">
                            <div class="deviceIndex">
                                <img src="../assets/img/model/shuzibiaoX.png" alt="">
                                <i>{{ item.index }}</i>
                            </div>
                            <img class="deviceModelImg" :src="getImagePath(item.img)" alt="">
                            <div class="deviceName">
                                <p>{{ item.name }}</p>
                                <span>{{ item.desc }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- 更多机型 -->
        <div class="otherModelWrap">
            <div class="home-title detail-title" style="margin-top: 144px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="model-title-chinese title-chinese blackText">更多机型</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Adapted vehicle'.toUpperCase() }}</span>

            </div>
            <ul class="fitList w12">
                <li v-for="item in otherModels" @click="toModelDetail(item)">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                </li>
            </ul>
        </div>

    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import productJson from '@/assets/data/productList.json'
export default {
    components: {
        Contact
    },
    data() {
        return {
            allProducts: [],
            productDetail: {},
            modelDetail: {},
            otherModels: [],
            type: null,
            typeName: null,
            productId: null,
        };
    },
    mounted() {
        this.allProducts = productJson
        this.productId = this.$route.query.id;
        this.type = this.$route.query.type;
        this.modelId = this.$route.query.objId;
        let currentTypeArr = this.allProducts[`list${this.type}`]
        this.productDetail = currentTypeArr.find(item => item.id == this.productId)
        this.modelDetail = this.productDetail.fitModel.find(item => item.id == this.modelId)
        this.otherModels = this.productDetail.fitModel.filter(item => item.id != this.modelId)
        this.typeName = this.type == 1 ? '智能感知' : this.type == 2 ? '智能驾驶' : this.type == 3 ? '智能硬件' : '智慧云平台'
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },
    methods: {
        // 产品咨询
    onlineContact(){
      this.$refs.Contact.handleShowContact()
    },
        // 跳转产品详情
        toProductDetail() {
            this.$router.push({
                path: '/productsDetail',
                query: {
                    id: this.productId,
                    type: this.type,
                }
            })
        },
        // 定位样式
        itemStyle(item) {
            const style = {
                left: item.real ? `${item.left - 7}px` : `${item.left}px`,
                top: item.real ? `${item.top - 3}px` : `${item.top}px`,
            };
            return style;
        },
        getImagePath(imageName) {
            return require(`@/assets${imageName}`);
        },
        scrollTo(index, flag) {
            // 获取对应的列表项元素
            const listRef = flag == 1 ? this.$refs.listItem : this.$refs.listItem2;
            const listItem = listRef.find(item => item.dataset.index == index);
            // 使用scrollIntoView()方法使列表项滚动到视口内
            listItem.scrollIntoView();
            window.scrollTo(0,window.scrollY-80)
        },
        // 切换其他机型
        toModelDetail(item) {
            this.modelId = item.id
            this.modelDetail = item
            this.otherModels = this.productDetail.fitModel.filter(item => item.id != this.modelId)

            // this.$router.push({
            //     path: '/productsModelDetail',
            //     query: {
            //         id: this.productId,
            //         type: this.type,
            //         objId: item.id
            //     }
            // })

            this.$nextTick(() => {
                window.scrollTo(0, 0)
            })
        }
    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/ModelDetail.vue